<script>
  import { getViolationChatMarks } from "@/modules/entities"
  import { violationChatMark } from '../api.js'
  import { getBasicInfo } from "@/modules/user";

  import moment from 'moment'
  // violationChatMarks
  function getOptions () {
    let optionsMap = {
      1: {
        sort: 3
      },
      2: {
        sort: 4
      },
      3: {
        sort: 2
      },
      4: {
        desc: '相关违规标记的上下文关联内容',
        sort: 1
      },
    }
    let options = getViolationChatMarks().map(item => ({
      ...item,
      ...optionsMap[item.key],
    }))
    options.sort((a,b) => a.sort - b.sort).push({ value: '取消标记', key: 0 })
    return options
  }
  export default {
    props: {
      data: Object,
      editable: Boolean,
      emptyText: {
        type: String,
        default: '暂无数据'
      },
    },
    data () {
      return {
        options: getOptions(),
        visible: false,
      }
    },
    computed: {
      typeNameMap () {
        return this.options?.reduce((map, item) => {
          map[item.key] = item.value
          return map
        }, {})
      },
      tagNameMap () {
        return this.options?.reduce((map, item) => {
          if (item.subList) {
            item.subList?.forEach(child => {
              map[child.id] = child.tagName
            })
          }
          return map
        }, {})
      },
    },
    methods: {
      async onChangeType(typeItem) {
        if (typeItem.subList) return
        if (typeItem.key === this.data.type && typeItem.key != 3) return
        this.visible = false
        let description
        if (typeItem.key == 3) {
          const { value } = await this.$prompt('', '请输入整改内容', {
            confirmButtonText: '确定',
            showCancelButton: false,
          })
          description = value
        }
        this.onSumbit({
          type: typeItem.key,
          description
        })
      },
      onChangeTag(tagItem) {
        this.visible = false
        this.onSumbit({
          type: tagItem.type,
          tagId: tagItem.id
        })
      },
      async onSumbit(params) {
        let { code } = await violationChatMark({
          id: this.data.id,
          ...params
        })
        if (code === 200) {

          let belongsTo = this.data?.belongsTo
          if (belongsTo) {
            let oldType = this.data.type
            let newType = params.type
            if (oldType != newType) {
              const inspectionSituation = JSON.parse(JSON.stringify(belongsTo?.inspection_situation || {}));
              if (oldType != 0 && inspectionSituation[oldType]) {
                inspectionSituation[oldType]--
                if (inspectionSituation[oldType] < 1) {
                  delete inspectionSituation[oldType]
                }
              }
              if (newType != 0) {
                if (inspectionSituation[newType]) {
                  inspectionSituation[newType]++
                } else {
                  inspectionSituation[newType] = 1
                }
              }
              this.$set(belongsTo, 'inspection_situation', inspectionSituation)
            }
          }

          this.data.type = params.type
          this.data.tagId = params.tagId
          this.data.description = params.description
          this.data.markAt = moment().format('YYYY-MM-DD HH:mm:ss')
          this.data.operaterName = getBasicInfo().name
        }
      }

    }
  }
</script>
<template>
  <div class="flex-ac mark" v-if="data">
    <div :class="[$style.tag, 'mark__tag']" v-if="data.type">{{ typeNameMap[data.type] }}</div>
    <div class="mr10 mark_desc" v-if="data.tagId">{{ tagNameMap[data.tagId] }}</div>
    <div class="mr10 mark_desc" v-if="data.description">{{ data.description }}</div>
    <el-popover
      v-if="editable"
      placement="right-start"
      v-model="visible"
    >
      <div class="w360">
        <div class="mb10">将内容标记为：</div>
        <div v-if="options.length" class="p5 pr20">
          <div v-for="group in options" :key="group.key" :class="$style.group_father">
            <div>
              <span
                :class="[
                  $style.group_label,
                  group.subList ? '' : $style.hover,
                  data.type == group.key ? $style.active : ''
                ]"
                @click="onChangeType(group)"
              >
                <i class="el-icon-circle-check mr5"></i>{{ group.value}}
              </span>
              <span :class="$style.group_desc" v-if="group.desc">{{ group.desc }}</span>
            </div>
            <div :class="$style.group_box" class="ml20">
              <span
                v-for="item in group.subList"
                :key="item.id"
                :class="[
                  $style.item_label,
                  data.tagId == item.id ? $style.active : ''
                ]"
                @click="onChangeTag(item)"
              >
                {{ item.tagName }}
              </span>
            </div>
          </div>
        </div>
        <div v-else>{{ emptyText }}</div>
      </div>
      <div slot="reference" :class="$style.add__icon" ref="add">
        <i class="el-icon-edit mt2 mr10 clickText"></i>
      </div>
    </el-popover>
    <span class="lint-item__small__text mr10">{{ data.markAt }}</span>
    <span class="fs12" style="color: #666;">标记人：{{ data.operaterName || (data.operater ? data.operater.realname : 'mochat标记') }}</span>
  </div>
</template>

<style lang="scss" module>
.hover {
  cursor: pointer;
  &:hover {
    color: red;
  }
}
.tag {
  height: 20px;
  padding: 3px 10px;
  color: #fff;
  background-color: #f00;
  font-size: 13px;
  line-height: 14px;
  margin-right: 10px;
  border-radius: 3px;
  box-sizing: border-box;
}

.group_label {
  font-size: 15px;
  color: #434343;
  line-height: 25px;
}
.group_desc {
  font-size: 12px;
  color: #ababab;
  margin-left: 5px;
}

.group_box {
  color: #ababab;
  text-align: justify;
  margin: 2px 0 10px;
}

.item_label {
  font-size: 12px;
  line-height: 22px;
  @extend .hover;
  &::after {
    content: '|';
    margin: 0 5px;
    color: #ababab;
  }
}

.active {
    color: #bd3124!important;
  }
.item_label:last-child::after {
  display: none;
}
</style>